// File: src/components/social/ActivityFeed/ActivityFeed.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";
import { NotificationItem } from "../NotificationItem/NotificationItem";

interface ActivityFeedProps {
  notifications: {
    id: string;
    message: string;
    timeAgo: string;
    read?: boolean;
  }[];
  onNotificationClick?: (id: string) => void;
}

const FeedContainer = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.md};
  box-shadow: ${({ theme }) => theme.elevations.low};
  width: 100%;
  max-width: 400px;
`;

export const SocialActivityFeed: React.FC<ActivityFeedProps> = ({
  notifications,
  onNotificationClick,
}) => {
  return (
    <FeedContainer>
      {notifications.map((notif) => (
        <NotificationItem
          key={notif.id}
          message={notif.message}
          timeAgo={notif.timeAgo}
          read={notif.read}
          onClick={() => onNotificationClick?.(notif.id)}
        />
      ))}
    </FeedContainer>
  );
};